export const headerHeight = 15;
export const contentHeight = 60;
export const footerHeight = 25;



// WEBPACK FOOTER //
// ./src/config/app.js